import { loadStripe } from "@stripe/stripe-js";
import { deploymentEnvironment } from "./Variables";

const STRIPE_PUBLISHABLE_KEY_LIVE = "pk_live_VOjgfcdWrQ8NvaxLMsqQ4VcI00E6fnRGep";
const STRIPE_PUBLISHABLE_KEY_TEST = "pk_test_B7HknqaFUiHiDRGUJE2l9jNB00pB8rQbU2";

export const stripePublishableKey = deploymentEnvironment
  ? STRIPE_PUBLISHABLE_KEY_LIVE
  : STRIPE_PUBLISHABLE_KEY_TEST;

export const stripePromise = loadStripe(stripePublishableKey);
